import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

type GetDailyBankAccountHistoryResponse = BaseResponse<Array<any>>;

interface GetDailyBankAccountHistoryRequest {
  month: number;
  year: number;
}

async function getDailyBankAccountHistory({
  month, year
}: GetDailyBankAccountHistoryRequest): Promise<GetDailyBankAccountHistoryResponse> {
  try {
    return (
      await axiosInstance.get(`/Dashboard/DailyBankAccountHistory?month=${month}&year=${year}`)
    ).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetDailyBankAccountHistory() {
  return useMutation<
    GetDailyBankAccountHistoryResponse,
    Error,
    GetDailyBankAccountHistoryRequest
  >((param) => getDailyBankAccountHistory(param));
}
